import { AnyAction } from '@reduxjs/toolkit';
import { GetCustomerApplicationsRoutine } from '../redux-routines';
import type { TCustomerApplicationsState } from '../interfaces';

export const initialState: TCustomerApplicationsState = {
  isFetching: false,
  data: [],
  error: null,
};

export const customerApplicationsReducer = (
  state: TCustomerApplicationsState = initialState,
  action: AnyAction,
): TCustomerApplicationsState => {
  switch (action.type) {
    case GetCustomerApplicationsRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: GetCustomerApplicationsRoutine.getSuccessPayload(action),
        error: null,
      };
    case GetCustomerApplicationsRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        data: [],
        error: null,
      };
    case GetCustomerApplicationsRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: [],
        error: GetCustomerApplicationsRoutine.getFailurePayload(action),
      };

    default:
      return state;
  }
};
